import { SystemStyleObject } from '@chakra-ui/react';

const baseStyle: SystemStyleObject = {
  borderWidth: 1,
  borderColor: `rgba(104, 48, 97, 0.14)`,
  borderRadius: 10,
  background: `white`,
  transition: `0.5s`,
  _focus: {
    borderWidth: 1,
    borderColor: `brand.orange`,
    boxShadow: `0 0 0 4px rgba(243, 146, 0, 0.12)`,
  },
};

const defaultProps: SystemStyleObject = {
  size: `sm`,
};

export const Textarea = {
  parts: [`addon`, `field`, `element`],
  baseStyle,
  defaultProps,
};
